export const formatSubCategory = (subCategory: string) => {
    return subCategory.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

/** Trim long number/reference strings from raw Plaid transaction names and cap at maxLen characters */
export function cleanRawName(name: string, maxLen = 20): string {
    const cleaned = name
        .replace(/[#*]*[\dX]{4,}[#*]*/g, '')  // strip 4+ digit/masked sequences
        .replace(/\s{2,}/g, ' ')
        .trim();
    const result = cleaned || name;
    return result.length > maxLen ? result.slice(0, maxLen).trimEnd() + '…' : result;
}